import React from 'react';
import './Chapters.scss';
import PullQuote from '../PullQuote/PullQuote';

function Chapter6() {
  return (
    <>
      <section className="chapter">
        <p className="chapter__paragraph">
          When Gutwein reached out to the Intel Foundation for support, the Foundation’s president,
          Pia Wilson-Body, asked him a simple question: how quickly do you think you can get this
          done? “Eight to twelve weeks minimum,” Gutwein responded. “That’s too long,” she said.
          “Can you do it in four weeks?” “That’s impossible, Gutwein said, “but why don’t we try?”
        </p>
        <p className="chapter__paragraph">
          Now that the PCC had been designed, the next big hurdle was getting it built. And once
          again, N50 team members rose to the occasion. “We asked ourselves, ‘where do we build
          these things?’ We got on the phone with one of our partners, WWT, and within 24 hours we
          were introduced to Exclusive Networks and gained access to their 10,000 square foot
          warehouse in Krakow, Poland. Exclusive Networks had employees who were eager to help.
          “Many of them had already brought Ukrainian refugees home,” Hartshorn recalls, “to live
          under their own roofs. They were walking the walk.” One day, early on, an employee
          approached David and his team and shook their hands, and promised he would do whatever it
          took to get the PCCs built on time. He was Ukrainian, and had been working in Poland since
          before the invasion. “He was emotionally gripped,” Hartshorn says. “We met many, many
          people like that.”
        </p>
        <p className="chapter__paragraph">
          Once the first PCC was built, N50 partner World Vision helped secure a place to deploy it
          at the RomExpo refugee center in Bucharest, Romania; other partners helped secure the
          truck to transport the PCC and the paperwork necessary to move it across borders.
        </p>
      </section>
      <section>
        <PullQuote
          quote={
            'We delivered our first containers in four weeks and two days. It’s something that one company, one individual, could never do on their own.'
          }
          author={'Daniel Gutwein'}
          source={'Senior Director, Education and N50 Project, Intel'}
        />
      </section>
      <section className="chapter">
        <p className="chapter__title">Opening Containers, Finding Hope</p>
        <p className="chapter__paragraph">
          David Hartshorn was there in Romania to watch the first PCC be deployed. “We had a truck
          with a crane dropping a 20 foot container into downtown Bucharest, Romania, that was fully
          kitted out,” Hartshorn recalls, “with solar power, and the ability to connect into the
          primary electrical grid; wireless communication services donated by the Vodafone
          Foundation, with satellite waiting in the wings, if necessary, to reestablish connectivity
          for these women and children. Wherever they were”.
        </p>
        <p className="chapter__paragraph">
          He watched beleaguered refugees use Dell ruggedized laptops in the PCC to communicate in
          their native language, to find food and shelter and work. He saw the relief wash over
          people as they re-established contact with their families who were still in the line of
          fire or scattered to the far corners of Europe. He watched their children find comfort in
          video games on laptops provided by the PCC. He saw people reconnecting not just with
          technology in abstract, but with some form of life as they’d been accustomed to living it.
        </p>

        <p className="chapter__paragraph">
          In the months since that day, an estimated 46,500 refugees have accessed the RomExpo in
          Bucharest, where the first PCC was deployed. In the weeks that followed N50 Partners CORE
          (Community Organized Relief Effort) with N50 Project Director Joe Simmons, identified more
          high-impact locations for PCCs to be positioned in Poland and Romania, where refugees
          congregated in need of support.
        </p>
        <p className="chapter__paragraph">
          To date, 7 total PCCs are operational, with additional units scheduled for deployment.
          Now, as the war enters a new phase, and millions of Ukrainians return home, Ukraine’s
          Ministry of Digital Transformation and the humanitarian group CORE have expressed interest
          in having N50 deploy their PCCs in a new way, within Ukraine, in order to perform
          e-government applications in areas devastated by the Russian invasion.
        </p>
      </section>
    </>
  );
}

export default Chapter6;
